<template>
    <select
        v-model="value"
        class="form-control"
        :name
        :required
    >
        <option
            v-for="(state, abbreviation) in statesAndAbbreviations"
            :key="abbreviation"
            :value="abbreviation"
        >
            {{ state }}
        </option>
    </select>
</template>

<script setup lang="ts">
import { statesAndAbbreviations } from '@/shared/constants/states-and-abbreviations';

const value = defineModel();

defineProps<{
    required?: boolean;
    name?: string;
}>();
</script>
